import React, { useContext, useEffect, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectDescription({ project_desc, project_id }) {
  const [showDescription, setShowDescription] = useState(false);
  const [description, setDescription] = useState("");
  const [loadingPopup, setLoadingPopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const toggleDescription = () => {
    setShowDescription(!showDescription);
  };

  useEffect(() => {
    if (project_desc) {
      setDescription(project_desc);
    }
  }, [project_desc]);

  const handleUpdateDesc = () => {
    setLoadingPopup(true);
    const listDescription = description;
    const listID = project_id;
    const projectData = {
      listDescription,
      listID,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}update-list-desc`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(projectData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Project description updated!",
            showConfirmButton: false,
            timer: 1500,
          });
          setShowDescription(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Project description not updated!",
            text: "Please try again.",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };

  return (
    <>
      <i
        className="desc-icon-toedit fa-regular fa-pen-to-square"
        onClick={toggleDescription}
      ></i>

      {showDescription && (
        <span style={{ position: "relative" }}>
          <textarea
            className="tooltiptext-po"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />

          <i
            className="po-des-close-icon fa-regular fa-rectangle-xmark"
            onClick={() => setShowDescription(false)}
          ></i>
          <div className="prj-desc-buttons-div">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setShowDescription(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn base-btn"
              onClick={handleUpdateDesc}
            >
              Update
            </button>
          </div>

          {loadingPopup && (
            <div className="linkedin-popup-wrapper">
              <div className="tab-pane fade show linkedin-div">
                <center>
                  <p style={{ fontSize: "18px" }}>Please wait. . .</p>
                  <br />
                  <img
                    src={LoadingIcon}
                    alt=""
                    style={{ width: "50px", marginRight: "5px" }}
                  />
                </center>
              </div>
            </div>
          )}
        </span>
      )}
    </>
  );
}
